import DetalleEmpleado from 'components/empleados/DetalleEmpleado'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewDetalleEmpleado = () => {
   
    


  return (
    <>
        <Row>
            <Col>
               <DetalleEmpleado></DetalleEmpleado>
            </Col>
        </Row>
    </>
  )
}

export default ViewDetalleEmpleado